import { useRecoilState } from "recoil";
import { callGTMAnalytics } from "../../helper/analyticsTag";
import utagObjectAtom from "../../recoils/useUtagObject/utagObjectAtom";

interface IProp {
  data: any;
}

export const MrfPart: React.FC<IProp> = ({ data }) => {
  const [utagObject] = useRecoilState(utagObjectAtom);
  return (
    <>
      {data.url !== '' ? (
        <a
          className="right-content__mnf-part-number"
          href={data.url}
          target="_blank"
          rel="noreferrer"
          onClick={()=>callGTMAnalytics(utagObject, "Link to Part", [data])}
          cookie-tracking={
            data && data.crossType && data.crossType?.crossName !== undefined
              ? 'ref_page_event=Link to Part;ref_page_category=' +
                data.crossType.crossName
              : ''
          }
        >
          {data.manufacturerProductNumber}
        </a>
      ) : (
        <span className="right-content__mnf-part-number pe-none">
          {data.manufacturerProductNumber}
        </span>
      )}
    </>
  );
};
